import { CodeBracketIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useAutomationsModal } from "./useAutomationsModal";
import { Icon } from "../../tremor/Icon";
import { Card } from "../../tremor/Card";
import React, { useMemo } from "react";
import { Title, Text } from "../../tremor/Text";
import { Button } from "../../tremor/Button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../tremor/Select";
import { useDashboard } from "../../layouts/Dashboard/useDashboard";
import { Tabs, TabsList, TabsTrigger } from "../../tremor/Tabs";
import { Input } from "../../tremor/Input";
const CONDITIONS = [{
        value: "lt",
        label: "Lesser than"
    }, {
        value: "gt",
        label: "Greater than"
    }, {
        value: "eq",
        label: "Equal to"
    }, {
        value: "neq",
        label: "Not equal to"
    }, {
        value: "lte",
        label: "Lesser than or equal to"
    }, {
        value: "gte",
        label: "Greater than or equal to"
    }];
export const AutomationConditionCard = ({}) => {
    const { selectedAutomation, setSelectedAutomation } = useAutomationsModal();
    const { widgets } = useDashboard();
    const options = useMemo(() => {
        return widgets.filter(a => a.type === "metric").map(a => ({
            label: a.title,
            value: a.id
        }));
    }, [widgets]);
    const updateCondition = (index, condition) => {
        const newConditions = (conditions.map((c, i) => {
            if (i === index) {
                return Object.assign(Object.assign({}, c), condition);
            }
            return c;
        }));
        setSelectedAutomation({ conditions: newConditions });
    };
    const addCondition = () => {
        const newConditions = [...conditions, {
                operand_id: options[0].value,
                reference_type: "static",
                operator: "lt",
                reference_value: "10"
            }];
        setSelectedAutomation({ conditions: newConditions });
    };
    const conditions = (selectedAutomation === null || selectedAutomation === void 0 ? void 0 : selectedAutomation.conditions) || [];
    return (React.createElement(Card, { className: "onvo-foreground-color onvo-max-w-screen-md !onvo-p-0" },
        React.createElement("div", { className: "onvo-background-color onvo-px-4 onvo-py-2 onvo-flex onvo-flex-row onvo-items-center onvo-justify-between onvo-rounded-t-2xl " + (conditions.length === 0 ? "onvo-rounded-b-2xl" : "") },
            React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-items-center onvo-gap-2" },
                React.createElement(Icon, { variant: "shadow", size: "xs", icon: CodeBracketIcon }),
                React.createElement(Title, { className: "onvo-text-sm" }, "Condition")),
            React.createElement(Button, { variant: "secondary", onClick: addCondition }, "Add condition")),
        conditions.length > 0 && (React.createElement("div", { className: "onvo-p-4 onvo-flex onvo-flex-col onvo-gap-2 onvo-border-solid onvo-border-t onvo-border-black/10 dark:onvo-border-white/10" }, conditions.map((condition, index) => (React.createElement("div", { key: index + "-condition", className: "onvo-flex onvo-flex-row onvo-items-center onvo-gap-2" },
            React.createElement(Select, { value: condition.operand_id, onValueChange: (value) => updateCondition(index, { operand_id: value }) },
                React.createElement(SelectTrigger, null,
                    React.createElement(SelectValue, { placeholder: "Select" })),
                React.createElement(SelectContent, null, options.map((item) => (React.createElement(SelectItem, { key: item.value, value: item.value }, item.label))))),
            React.createElement(Select, { value: condition.operator, onValueChange: (value) => updateCondition(index, { operator: value }) },
                React.createElement(SelectTrigger, null,
                    React.createElement(SelectValue, { placeholder: "Select" })),
                React.createElement(SelectContent, null, CONDITIONS.map((item) => (React.createElement(SelectItem, { key: item.value, value: item.value }, item.label))))),
            React.createElement(Tabs, { defaultValue: "static", value: condition.reference_type, onValueChange: value => updateCondition(index, { reference_type: value }) },
                React.createElement(TabsList, { variant: "solid" },
                    React.createElement(TabsTrigger, { value: "static" }, "Static"),
                    React.createElement(TabsTrigger, { value: "dynamic" }, "Dynamic"))),
            condition.reference_type === "static" ?
                (React.createElement(Input, { value: condition.reference_value, onChange: (e) => updateCondition(index, { reference_value: e.target.value }) })) :
                (React.createElement(Select, { value: condition.reference_id, onValueChange: (value) => updateCondition(index, { reference_id: value }) },
                    React.createElement(SelectTrigger, null,
                        React.createElement(SelectValue, { placeholder: "Select" })),
                    React.createElement(SelectContent, null, options.map((item) => (React.createElement(SelectItem, { key: item.value, value: item.value }, item.label)))))),
            React.createElement(Icon, { onClick: () => setSelectedAutomation({ conditions: conditions.filter((_, i) => i !== index) }), variant: "shadow", className: "!onvo-text-red-500 onvo-cursor-pointer", icon: TrashIcon })))))),
        conditions.length > 1 && (React.createElement("div", { className: "onvo-py-1 onvo-px-4 onvo-flex onvo-flex-row onvo-justify-between onvo-items-center onvo-border-solid onvo-border-t onvo-border-black/10 dark:onvo-border-white/10" },
            React.createElement(Tabs, { defaultValue: "static", value: (selectedAutomation === null || selectedAutomation === void 0 ? void 0 : selectedAutomation.condition_operator) || "and", onValueChange: value => setSelectedAutomation({ condition_operator: value }) },
                React.createElement(TabsList, { variant: "solid" },
                    React.createElement(TabsTrigger, { value: "and" }, "AND"),
                    React.createElement(TabsTrigger, { value: "or" }, "OR"))),
            ((selectedAutomation === null || selectedAutomation === void 0 ? void 0 : selectedAutomation.condition_operator) || "and") === "and" ? (React.createElement(Text, null, "Report is only sent when all conditions are met")) : (React.createElement(Text, null, "Report is sent when any condition is met"))))));
};
//# sourceMappingURL=AutomationConditionCard.js.map